import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom } from 'jotai';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { TArticleDetail } from 'shared/models/article';

export interface IPOIPosts {
  items: TArticleDetail[];
  hasMore: boolean;
  sessionImprId: string;
}

type TPOIPostsStore = { [key: string]: PromiseOrValue<IPOIPosts> | undefined };

export const $POIPostStore = atom({} as TPOIPostsStore);

export const $POIPosts = safeAtomFamily((poiId: string) => {
  const a = atom<PromiseOrValue<IPOIPosts>, [PromiseOrValue<IPOIPosts>], void>(
    (get) => {
      const data = get($POIPostStore)[poiId];
      if (!data) {
        return Unreachable('no data in $POIPosts');
      }
      return data;
    },
    (get, set, input: PromiseOrValue<IPOIPosts>) => {
      const old = get($POIPostStore);
      set($POIPostStore, { ...old, [poiId]: input });
    },
  );

  a.debugLabel = `$POIPosts+${encodeURIComponent(poiId)}`;

  return a;
});

export const $POIPostsLoadmore = safeAtomFamily((poiId: string) => {
  const a = atom<null, [IPOIPosts], void>(null, async (get, set, input) => {
    const store = get($POIPostStore);
    const old = await store[poiId];

    if (old) {
      set($POIPostStore, {
        ...store,
        [poiId]: {
          ...input,
          items: [...old.items, ...input.items],
        },
      });
    }
  });

  a.debugLabel = `$POIPostsLoadmore+${encodeURIComponent(poiId)}`;
  return a;
});
